<template lang="html">
<div class="tabs-layout-header-items pad">
    <div class="items-left">

        <ul class="peoples_list">
            <li v-if="petition.paralegalDetails!=null">
                <figure>
                    <img class="user-image" src="@/assets/images/main/avatar2.svg" />
                </figure>
                <div class="peoples-dropdown">
                    <h6>
                        {{petition.paralegalDetails.name}}
                        <span>Paralegal</span>
                    </h6>
                    <p>
                        <a href="#">{{petition.paralegalDetails.email}}</a>
                        <span>{{petition.paralegalDetails.phone}}</span>
                    </p>
                </div>
            </li>

            <li v-if="petition.supervisorDetails!=null">
                <figure>
                    <img class="user-image" src="@/assets/images/main/avatar2.svg" />
                </figure>
                <div class="peoples-dropdown">
                    <h6>
                        {{petition.supervisorDetails.name}}
                        <span>Supervisor</span>
                    </h6>
                    <p>
                        <a href="#">{{petition.supervisorDetails.email}}</a>
                        <span>{{petition.supervisorDetails.phone}}</span>
                    </p>
                </div>
            </li>

            <li v-if="petition.attorneyDetails!=null">
                <figure>
                    <img class="user-image" src="@/assets/images/main/avatar2.svg" />
                </figure>
                <div class="peoples-dropdown">
                    <h6>
                        {{petition.attorneyDetails.name}}
                        <span>Attorney</span>
                    </h6>
                    <p>
                        <a href="#">{{petition.attorneyDetails.email}}</a>
                        <span>{{petition.attorneyDetails.phone}}</span>
                    </p>
                </div>
            </li>
        </ul>
    </div>

    <div class="items-right">
        <ul>
            <li>

                <div v-if="[1,2,4].indexOf(currentRole) >= 0 && petition.statusId > 1 && !petition.enableEditOption" class="documents_toggle" @click="checker(false)">
                    <label>Unlock Editing</label>
                    <figure>
                        <img src="@/assets/images/main/unlock.svg" />
                    </figure>
                </div>

                <div v-if="[1,2,4].indexOf(currentRole) >= 0 && petition.statusId > 1 && petition.enableEditOption" class="documents_toggle" @click="checker(true)">
                    <label>Lock Editing</label>
                    <figure>
                        <img src="@/assets/images/main/lock.svg" />
                    </figure>
                </div>

            </li>
            <li class="flowdropdown" v-if="checkActionconditions && petition.statusId < 11">
                <vs-dropdown vs-custom-content vs-trigger-click>
                    <vs-button color="primary" class="actions-btn" type="border" icon-pack="feather" icon="icon-chevron-down" icon-after>Actions</vs-button>
                    <vs-dropdown-menu ref="filter_menu" class="actions-content petition-action-content">
                        <ul>
                            <li v-if="currentRole && [1,2].indexOf(currentRole) >= 0 && petition.paralegalDetails==null">
                                <a href="javascript:;" @click="AssignParalegal=true">Assign Paralegal</a>
                            </li>

                            <li v-if="currentRole && [1,4].indexOf(currentRole) >= 0 && petition.paralegalDetails!=null &&  petition.attorneyDetails == null">
                                <a href="javascript:;" @click="assigntorole(5)">Submit to Attorney</a>
                            </li>
                            <li v-if="currentRole && [1,4,5].indexOf(currentRole) >= 0 && petition.paralegalDetails!=null &&  petition.attorneyDetails == null">
                              <a href="javascript:;" @click="showPetitionersign()">Send for Signing</a>
                            </li>

                        </ul>
                    </vs-dropdown-menu>
                </vs-dropdown>
                <li v-if="checkActionconditionsalt"></li>
            </li>
            <li>
                <div class="dropdown-button-container status-button">
                    <vs-button>
                        <span class="status_approved" v-if="petition.currentActivity =='QUESTIONNIRE_REJECTED'">Questionnire Rejected</span>
                        <span v-else class="status_approved">{{petition.statusDetails.name}}</span>
                    </vs-button>
                </div>
            </li>

            <!--    <li><button class="btn btn-brown" @click="AssignParalegal=true" >Assign Paralegal</button></li>
                  <li><button class="btn btn-brown" @click="SubmitParalegal=true">Submit to Supervisor</button></li>
        -->
            <!-- *********************** using html  ********************

        -->
            <li style="display:none">
                <!-- history side bar-->
                <template lang="html">
                    <div id="parentx">
                        <img @click.stop="active=true" class="cursor-pointer" src="@/assets/images/main/settings.svg" />
                        <vs-sidebar position-right parent="body" default-index="1" class="sidebarx history-sidebar 4" spacer v-model="active">
                            <div class="header-sidebar" slot="header">
                                <h4>Petition History</h4>
                                <figure>
                                    <img @click="active=false;gethistory()" src="@/assets/images/main/icon-remove.svg" />
                                </figure>
                            </div>
                            <VuePerfectScrollbar class="scroll-area">
                                <div class="timeline-sidebar">
                                    <ul>
                                        <li v-for="(history, index) in petitionhistory" :key="index">
                                            <div class="timeline-icon">
                                                <i class="icon IP-tick-sign"></i>
                                            </div>
                                            <div class="timeline-info">
                                                <button class="btn active-green ml-0">{{history.createdByRoleName}}</button>
                                                <ul>
                                                    <li>
                                                        <h3>{{history.title}}</h3>
                                                        <span>{{history.description}}</span>

                                                        <span>{{history.createdOn | formatDateTime}}</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </VuePerfectScrollbar>
                        </vs-sidebar>
                    </div>
                </template>
            </li>
        </ul>

        <vs-popup class="Change_petition_wrap" title="Upload Signed Documents" :active.sync="uploadSignedPopup">
            <div class="Change_petition">
                <div class="vx-col w-full marb10">
                    <div v-for="(docData, index) in documentData" :key="index">
                        <div class="vx-row">
                            <div class="vx-col w-full">
                                <vx-input-group class="form-input-group select-upload-group">
                                    <div class="uploadsec_wrap">
                                        <div class="w-full">
                                            <!-- @input="selectedDocuments(index, docData.documentUploaded)" -->
                                            <file-upload :emitCategory="'docData.documentUploaded'"  @updateData="updateData" v-model="docData.documentUploaded" class="file-upload-input mb-0" style="height:50px;" :name="'pdocuments'+index" :multiple="true" :hideSelected="true" v-validate="'required'" label="Forms and Letters" data-vv-as="Forms and Letters" :accept="allDocEntity" >
                                                <img class="file-icon" src="@/assets/images/main/file-upload.svg" />
                                                Upload
                                            </file-upload>
                                            <span class="file-type">(File Type: PDF, DOC, JPEG, PNG. Max file size: 200MB)</span>
                                            <span class="text-danger text-sm" v-show="errors.has('pdocuments'+index)">{{ errors.first('documents'+index) }}</span>
                                            <VuePerfectScrollbar class="scrollbardoc">
                                                <div class="uploded-files_wrap" v-if="docData.documentUploaded && docData.documentUploaded.length >0 ">
                                                    <div class="w-full" v-for="(fil, fileindex) in docData.documentUploaded" :key="fileindex">
                                                        <div class="uploded-files">
                                                            <vx-input-group class="form-input-group">
                                                                <vs-input v-on:keyup="fileNameChenged(index ,fileindex)" required class="w-full" :name="'fName'+index" v-model="docData.documentUploaded[fileindex]['name']" data-vv-as="File Name" />
                                                                <span class="text-danger text-sm" v-show="!docData.documentUploaded[fileindex]['name']">Please Enter file name</span>
                                                                <span class="text-danger text-sm" v-show="errors.has('fName'+index)">{{ errors.first('fName'+index) }}</span>

                                                                <div class="delete" style="z-index:999" @click="remove_uploadedfile(index ,fileindex)">
                                                                    <img src="@/assets/images/main/cross.svg" />
                                                                </div>
                                                            </vx-input-group>
                                                        </div>
                                                    </div>
                                                </div>
                                            </VuePerfectScrollbar>
                                        </div>
                                    </div>
                                </vx-input-group>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="actions_footer">
                <button @click="fileuploadPopup=false" class="btn cancel">Cancel</button>
                <button class="btn" v-bind:disble="disable_uploadBtn" @click="uploadFiles()">
                    <img class="loader" v-if="fuploder" src="@/assets/images/main/loader.gif" />Save
                </button>
            </div>
        </vs-popup>

        <vs-popup class="holamundo main-popup" title="Update Tracking Details" :active.sync="updateTrackingPopup">
            <!-- <vs-popup class="holamundo"  title="Lorem ipsum dolor sit amet" :active.sync="filingFeesPopup"> -->
            <form data-vv-scope="trackingform" class="trackingform">
                <div class="form-container">
                    <div v-if="this.petition.courierTrackingCategory==null">
                        <div class="vx-col w-full">
                            <vs-input :key="'firstname'" style="width:100%" data-vv-as="Tracking ID" v-validate="'required'" v-model="tracking.trackingId" name="trackingId" label="Tracking ID" />
                        </div>
                        <div class="vx-col w-full">

                            <multiselect data-vv-as="Courier" v-model="tracking.courier" @input="changedCourier()" :options="courierList" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Select Courier" label="name" track-by="name" :preselect-first="false">
                                <template slot="selection" slot-scope="{ values, search, isOpen }">
                                    <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span>
                                </template>
                            </multiselect>
                        </div>
                    </div>

                    <div v-if="this.petition.courierTrackingCategory!=null">
                        <div class="vx-col w-full">
                            <vs-input :key="'receiptNumber'" style="width:100%" data-vv-as="Receipt Number" v-validate="'required'" v-model="tracking.receiptNumber" name="receiptNumber" label="Receipt Number" />
                        </div>
                        <div class="vx-col w-full">
                            <vs-input :key="'receiptName'" style="width:100%" data-vv-as="Comments" v-validate="'required'" v-model="tracking.receiptName" name="receiptName" label="Comments" />
                        </div>

                        <div class="vx-col w-full upload-wrap">
                            <!-- @input="selectedDocuments(index, trackingdoc)" -->
                            <file-upload :emitCategory="'trackingdoc'"  @updateData="updateData"  v-model="trackingdoc" class="file-upload-input mb-0" style="height:50px;" name="trackingdoc" :multiple="false" v-validate="'required'" data-vv-as="Forms and Letters" :accept="allDocEntity" >
                                <img class="file-icon" src="@/assets/images/main/file-upload.svg" />
                                Upload *
                            </file-upload>
                            <span class="file-type marb15">(File Type: PDF, DOC, JPEG, PNG. Max file size: 200MB)</span>

                            <div class="file_view" v-for="(file, fileindex) in trackingdoc" :key="fileindex">{{file.name}}</div>
                        </div>
                    </div>
                </div>

                <div class="popup-footer">
                    <vs-button color="success" @click="updateTracking" class="save" type="filled">Submit</vs-button>
                </div>
            </form>
        </vs-popup>

        <vs-popup class="holamundo main-popup trackingpopup" title="Update USCIS Status" :active.sync="updateUSCISstatusPopup">
            <!-- <vs-popup class="holamundo"  title="Lorem ipsum dolor sit amet" :active.sync="filingFeesPopup"> -->
            <form data-vv-scope="uscisstatus" class="trackingform">
                <div class="form-container">
                    <div class="vx-row">
                        <div class="vx-col w-full">
                            <div class="con-select w-full select-large marb15">
                                <label class="title_label">Case Status</label>
                                <multiselect name="casestatus" v-validate="'required'" v-model="casestatus" :show-labels="false" track-by="value" label="text" data-vv-as="Case Status" placeholder="Choose Case Status" :options="uscisstatuslist" :searchable="true" :allow-empty="false"></multiselect>
                            </div>

                            <span class="text-danger text-sm" v-show="errors.has('uscisstatus.casestatus')">{{ errors.first("uscisstatus.casestatus") }}</span>
                        </div>
                        <div v-if="casestatus.value =='USCIS_RECEIVED_RFE' " class="vs-col d-felx d-received_wrap">
                            <div class="vs-col">
                                <label class="date-picker-label">RFE Issued Date</label>

                                <datepicker  :typeable="true" icon-pack="IntakePortal" icon-after name="issuedDate" v-model="issuedDate" v-validate="'required'" icon="IP-calendar-1" data-vv-as="Business established date" placeholder="MM/DD/YYYY" :open-date="new Date(openDate)" :disabled-dates="{from: new Date(startEligibleDate)}"></datepicker>
                                <span class="text-danger text-sm" v-show="errors.has('petitioner.')">{{ errors.first("petitioner.") }}</span>
                            </div>

                            <div class="vs-col">
                                <label class="date-picker-label">RFE Recevied Date</label>
                                <datepicker  :typeable="true" icon-pack="IntakePortal" icon-after name="receivedDate" v-model="receivedDate" v-validate="'required'" icon="IP-calendar-1" data-vv-as="Business established date" placeholder="MM/DD/YYYY" :open-date="new Date(openDate)" :disabled-dates="{from: new Date(startEligibleDate)}"></datepicker>
                                <span class="text-danger text-sm" v-show="errors.has('receivedDate.')">{{ errors.first("receivedDate.") }}</span>
                            </div>

                            <div class="vs-col">
                                <label class="date-picker-label">RFE Due Date</label>
                                <datepicker  :typeable="true" icon-pack="IntakePortal" icon-after name="dueDate" v-model="dueDate" v-validate="'required'" icon="IP-calendar-1" data-vv-as="Business established date" placeholder="MM/DD/YYYY" :open-date="new Date(openDate)" :disabled-dates="{from: new Date(startEligibleDate)}"></datepicker>
                                <span class="text-danger text-sm" v-show="errors.has('dueDate.')">{{ errors.first("dueDate.") }}</span>
                            </div>
                        </div>
                        <div class="vx-col w-full upload-wrap">
                            <!-- @input="selectedDocuments(index, uscisdocument)" -->
                            <file-upload :emitCategory="'uscisdocument'"  @updateData="updateData" v-model="uscisdocument" class="file-upload-input mb-0" style="height:50px;" name="trackingdoc" :multiple="false" v-validate="'required'" data-vv-as="Forms and Letters" :accept="allDocEntity" >
                                <img class="file-icon" src="@/assets/images/main/file-upload.svg" />
                                Upload
                            </file-upload>
                            <span class="file-type marb15">(File Type: PDF, DOC, JPEG, PNG. Max file size: 200MB)</span>

                            <div class="file_view" v-for="(file, fileindex) in uscisdocument" :key="fileindex">{{file.name}}</div>
                        </div>

                        <div class="vx-col w-full">
                            <!-- <vs-textarea data-vv-as="Comments" v-validate="'required'" v-model="usciscomments" name="usciscomments" label="Comments…" class="w-full" /> -->
                            <ckeditor  data-vv-as="Comments" v-validate="'required'" v-model="usciscomments" name="usciscomments" label="Comments…" class="w-full" :editor="editor" :config="editorConfig"></ckeditor>

                            <span class="text-danger text-sm" v-show="errors.has('uscisstatus.usciscomments')">{{ errors.first("uscisstatus.usciscomments") }}</span>
                        </div>
                    </div>
                </div>

                <div class="popup-footer">
                    <vs-button color="success" @click="petitionApproval" class="save" type="filled">Submit</vs-button>
                </div>
            </form>
        </vs-popup>

        <vs-popup class="holamundo main-popup filling_popup" title="Submit for Signing" :active.sync="requestsignPopup">
            <form data-vv-scope="requestsignform">
                <div class="form-container padt25">
                    <div class="vx-col w-full">
                        <!-- <vs-textarea data-vv-as="Comments" v-validate="'required'" v-model="requestsignformcomments" name="requestsignformcomments" label="Comments…" class="w-full" /> -->
                        <ckeditor data-vv-as="Comments" v-validate="'required'" v-model="requestsignformcomments" name="requestsignformcomments" label="Comments…" class="w-full"  :editor="editor" :config="editorConfig"></ckeditor>

                        <span class="text-danger text-sm" v-show="errors.has('requestsignform.requestsignformcomments')">{{ errors.first("requestsignform.requestsignformcomments") }}</span>
                    </div>
                </div>

                <div class="popup-footer">
                    <vs-button color="success" @click="submitpetitionrequest" class="save" type="filled">Submit</vs-button>
                </div>
            </form>
        </vs-popup>

        <vs-popup v-if="assigntoRolePopup" class="holamundo main-popup" :title="assigntoRoletitle" :active.sync="assigntoRolePopup">
            <form data-vv-scope="assignroleform">
                <div class="form-container">
                    <div class="vx-row">
                        <div class="vx-col w-full">
                            <div class="form_group">
                                <div class="con-select w-full select-large">
                                    <multiselect name="assigntorole" v-validate="'required'" v-model="assigntoroleModel" :show-labels="false" track-by="id" label="name" :data-vv-as="assigntoroletxt" :placeholder="chooseassigntorole" :options="selectedroleslist" :searchable="true" :allow-empty="false"></multiselect>
                                </div>
                                <span class="text-danger text-sm" v-show="errors.has('assignroleform.assigntorole')">{{ errors.first("assignroleform.assigntorole") }}</span>
                            </div>
                        </div>

                        <div class="vx-col w-full">
                            <div class="form_group">
                            <!-- <vs-textarea data-vv-as="Comments" v-validate="'required'" v-model="assignedrolecomments" name="assignedrolecomments" label="Comments…" class="w-full" /> -->
                            <ckeditor data-vv-as="Comments" v-validate="'required'" v-model="assignedrolecomments" name="assignedrolecomments" label="Comments…" class="w-full"  :editor="editor" :config="editorConfig"></ckeditor>

                            <span class="text-danger text-sm" v-show="errors.has('assignroleform.assignedrolecomments')">{{ errors.first("assignroleform.assignedrolecomments") }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="text-danger text-sm formerrors" v-show="paralegalformerrors">
                        <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal" icon="IP-information-button" active="true">{{ paralegalformerrors }}</vs-alert>
                    </div>
                </div>
                <div class="popup-footer">
                    <vs-button color="success" @click="submitassignrole" class="save" type="filled">Assign</vs-button>
                </div>
            </form>
        </vs-popup>

     

        

        <vs-popup v-if="AssignParalegal" class="holamundo main-popup" title="Assign Paralegal" :active.sync="AssignParalegal">
            <form data-vv-scope="paralegalfoform">
                <div class="form-container">
                    <div class="vx-row">
                        <div class="vx-col w-full">
                            <div class="con-select w-full select-large">
                                <label for class="vs-select--label">Paralegal</label>
                                <multiselect name="paralegal" v-validate="'required'" v-model="paralegalModel" :show-labels="false" track-by="id" label="name" data-vv-as="Paralegal" placeholder="Select Paralegal" :options="paralegallist" :searchable="true" :allow-empty="false"></multiselect>
                            </div>

                            <span class="text-danger text-sm" v-show="errors.has('paralegalfoform.paralegal')">{{ errors.first("paralegalfoform.paralegal") }}</span>
                        </div>
                        <div class="vx-col w-full">
                            <!-- <vs-textarea data-vv-as="Comments" v-validate="'required'" v-model="paralegalcomments" name="paralegalcomments" label="Comments…" class="w-full" /> -->
                            <ckeditor data-vv-as="Comments" v-validate="'required'" v-model="paralegalcomments" name="paralegalcomments" label="Comments…" class="w-full"   :editor="editor" :config="editorConfig"></ckeditor>

                            <span class="text-danger text-sm" v-show="errors.has('paralegalfoform.paralegalcomments')">{{ errors.first("paralegalfoform.paralegalcomments") }}</span>
                        </div>
                    </div>
                    <div class="text-danger text-sm formerrors" v-show="paralegalformerrors">
                        <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal" icon="IP-information-button" active="true">{{ paralegalformerrors }}</vs-alert>
                    </div>
                </div>
                <div class="popup-footer">
                    <vs-button color="success" @click="assignparalegalform" class="save" type="filled">Assign</vs-button>
                </div>
            </form>
        </vs-popup>

     


    </div>
</div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Vue from "vue";
// import FileUpload from "vue-upload-component/src";
import Datepicker from "vuejs-datepicker-inv";
import moment from "moment";
import JQuery from "jquery";

Vue.use( CKEditor );
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import FileUpload from "@/views/FileUpload.vue";
export default {
    components: {
        FileUpload,
        VuePerfectScrollbar,
        Datepicker,
    },
    props: {
        petition: {
            type: Object,
            default: null,
        },
        currentRole: {
            type: Number,
            default: null,
        },
    },
    computed: {
      checkActionconditionsalt(){
        

      },
        checkActionconditions() {
            var currentRole = this.currentRole;
            var petition = this.petition;
            if (currentRole == 1) return true;

            if ((currentRole && [6].includes(currentRole) && petition.questionnaireFilled && petition.statusId == 1 && petition.currentActivity != 'QUESTIONNIRE_APPROVED') 
              || (currentRole && [6].includes(currentRole) && petition.questionnaireFilled && petition.statusId == 1 && petition.currentActivity != 'QUESTIONNIRE_APPROVED') || (currentRole && currentRole == 2 && petition.paralegalDetails == null) || (currentRole && currentRole == 2 && petition.supervisorDetails == null) || (currentRole && currentRole == 3 && !petition.paralegalApproved) || (currentRole && currentRole == 3 && !petition.paralegalApproved) || (currentRole && currentRole == 4 && petition.offshoreManagerDetails && petition.offshoreManagerDetails.length == 0) || (currentRole && currentRole == 8 && petition.offshoreUserDetails == null) 
              || (currentRole && currentRole == 4 && petition.paralegalApproved && petition.attorneyDetails == null) 
              || (currentRole && currentRole == 6 && petition.petitionerSignRequested && petition.statusId < 9) 
              || (currentRole && petition.attorneyDetails != null && (!petition.filingFeeDetails || (petition.filingFeeDetails && petition.filingFeeDetails.length == 0)) && (currentRole == 3 || currentRole == 4 || currentRole == 5)) || (currentRole && (currentRole == 5) && petition.filingFeeDetails && petition.filingFeeDetails.amount > 0 && !petition.petitionerSignRequested) || (currentRole && petition.courierTrackingCategory == null && petition.petitionerSignRequested && (currentRole == 2 || currentRole == 3 || currentRole == 4 || currentRole == 5) && petition.attorneyDetails != null) || (currentRole && petition.courierTrackingCategory == 'UPDATE_TRACKING_NUMBER' && petition.petitionerSignRequested && (currentRole == 2 || currentRole == 3 || currentRole == 4 || currentRole == 5) && petition.attorneyDetails != null) || (currentRole && petition.courierTrackingCategory == 'UPDATE_USCIS_RECEIPT_NUMBER' && petition.statusId != 13 && petition.petitionerSignRequested && (currentRole == 2 || currentRole == 3 || currentRole == 4 || currentRole == 5) && petition.attorneyDetails != null)) {
                return true;

            } else {
                return false;

            }

        },
    },
    methods: {},
    data: () => ({
        
 editor: ClassicEditor,
 editorConfig: {
     toolbar: [ 'bold', 'italic', '|', 'undo','redo'  ,'NumberedList', 'BulletedList', ],
 },
        disable_uploadBtn: false,
        fuploder: false,
        filingFeeData: [{
            amount: null,
            invoice: false,
            description: "",
        }, ],
        tracking: {},
        uscisstatuslist: [{
                value: "USCIS_APPROVED",
                text: "Case Approved",
            },
            {
                value: "USCIS_RECEIVED_RFE",
                text: "RFE Received",
            },
            {
                value: "USCIS_DENIED",
                text: "Case Denied",
            },
            {
                value: "USCIS_WITHDRAWN",
                text: "Case Withdrawn",
            },
        ],
        trackingdoc: [],
        issuedDate: null,
        receivedDate: null,
        dueCate: null,
        openDate: new Date().setFullYear(new Date().getFullYear()),
        startEligibleDate: new Date().setFullYear(new Date().getFullYear()),
        updateTrackingPopup: false,
        updateUSCISstatusPopup: false,
        filingFeesPopup: false,
        casestatus: {},
        uscisdocument: [],
        usciscomments: "",
        requestsignPopup: false,
        assigntoRoletitle: "",
        requestsignformcomments: "",
        assigntoroletxt: "",
        chooseassigntorole: "",
        assignedRoleId: null,
        assigntoRolePopup: false,
        approvalstatus: false,
        approveaction: false,
        rolesubmitaction: "",
        replaceParalegaltitle: "Replace Paralegal",
        paralegalformerrors: "",
        supervisorcomments: "",
        assignedrolecomments: "",
        paralegalcomments: "",
        petitionhistory: [],
        SubmitParalegal: false,
        SuccessQuestionnaire: false,
        AssignParalegal: false,
        paralegalModel: [],
        assigntoroleModel: [],
        supervisorMode: [],
        paralegallist: [],
        supervisorlist: [],
        selectedroleslist: [],
        replaceParalegal: false,
        approveParalegalform: false,
        active: false,
        approveRejectPop: false,
        approveRejectTitle: "Approve Questionnire",
        approveRejecInstructions: "",
        actionType: "approved",
        pactiontype: "ASSIGN_PARALEGAL",
        is_change_paralegal: false,
        is_change_superwiser: false,
        uploadSignedPopup: false,
        documents: [],
        documentData: [{
            type: "Forms, Letters and Others",
            documentUploaded: [],
        }, ],
        formsData: [],
        courierList: [],
        documentsUpload: true,
        lockDocumentsPopup: false,
        lockDocumentsPopupTitle: "",
        documentlockformcomments: ''
    }),
    methods: {
        updateData(docs, category){
            if(category == 'docData.documentUploaded' ){
                this.docData.documentUploaded = docs
            }
            if(category == 'trackingdoc' ){
                this.trackingdoc = docs
            }
            if(category == 'uscisdocument' ){
                this.uscisdocument = docs
            }
        },
        getCourierList() {
            let postdata = {};

            this.$store.dispatch("getCourierList", postdata).then((response) => {
                this.courierList = response;
            });
        },

        fetchSignedUrl(value) {
            
            value.document = value.document.replace(this.$globalgonfig._S3URL, "");
            value.document = value.document.replace(this.$globalgonfig._S3URLAWS, "");

            let postdata = {
                keyName: value.document,
            };
            this.$store.dispatch("getSignedUrl", postdata).then((response) => {
                window.open(response.data.result.data, "_blank");
            });
        },
        remove(item, type) {
            type.splice(type.indexOf(item), 1);
            return false;
        },
        uploadFiles() {
            let formData = new FormData();
            let postData = {};
            let count = 0;
            var self = this;

            let payload_data = {
                petitionId: this.petition._id,
                comment: "Petition Signed",
            };
            // "action": "QUESTIONNIRE_APPROVED" // "QUESTIONNIRE_REJECTED" / "CASE_APPROVED" / "LCA_CERTIFIED_FOR_PETITION" / "READY_FOR_FILING" / "USCIS_APPROVED" / "USCIS_RECEIVED_RFE" / "USCIS_DENIED"

            payload_data["action"] = "READY_FOR_FILING";

            this.$store
                .dispatch("manageApproval_process", payload_data)
                .then((response) => {});

            this.documentData.documentUploaded.forEach(function (doc) {
                var docsp = [];
                docsp.push(doc);
                let uploadPayload = {
                    documents: docsp,
                    petitionId: self.petition._id,
                };
                
                self.$store
                    .dispatch("uploadScannedCopies", uploadPayload)
                    .then((response) => {
                        
                    });
            });

            setTimeout(function () {
                self.$emit("updatepetition");
                // self.showMessages(response.message);
                self.uploadSignedPopup = false;
            });
        },
        submitSignedDocuments() {
            this.uploadSignedPopup = true;
        },
        addfilingfee: function () {
            this.filingFeeData.push({
                amount: null,
                description: "",
            });
        },
        removefilingfee: function (index) {
            Vue.delete(this.filingFeeData, index);
        },
        showfilingFeesPopup() {
            if (
                this.petition.filingFeeDetails &&
                this.petition.filingFeeDetails.amount > 0
            ) {
                this.filingFeeData = [];
                this.filingFeeData = this.petition.filingFeeDetails.feeDetails;
            }

            this.filingFeesPopup = true;
        },
        showPetitionersign() {
            this.requestsignPopup = true;
        },
        updateUSCISstatus() {
            this.updateUSCISstatusPopup = true;
        },
        updateTrackingDetails() {
            this.updateTrackingPopup = true;

            this.tracking.documents = [];
            this.uscisdocument = [];
            this.trackingdoc = [];
        },

        changedCourier() {
            this.tracking.trackingUrl = this.tracking["courier"]["code"];
            this.tracking.courierCode = this.tracking["courier"]["code"];
        },
        updateTracking() {

            this.$validator.validateAll("trackingform").then((result) => {
                if (result) {
                    this.tracking.petitionId = this.petition._id;
                    this.tracking.action =
                        this.petition.courierTrackingCategory != "UPDATE_TRACKING_NUMBER" ?
                        "UPDATE_TRACKING_NUMBER" :
                        "UPDATE_USCIS_RECEIPT_NUMBER";
                    //alert(JSON.stringify(this.tracking));

                    this.$store
                        .dispatch("updateTrackingDetails", this.tracking)
                        .then((response) => {
                            this.$emit("updatepetition");
                            this.showMessages(response.message);
                            this.updateTrackingPopup = false;
                            this.$emit("loadstatus");
                        });

                }

            })

        },
        assigntorole(roleId) {
            this.assigntoRolePopup = true;
            this.assignedRoleId = roleId;
            if (roleId == 9) {
                this.assigntoRoletitle = "Submit to Offshore";
                this.assigntoroletxt = "Offshore";
                this.chooseassigntorole = "Choose Offshore";
                this.rolesubmitaction = "ASSIGN_OFFSHORE_USER";
            }
            if (roleId == 5) {
                this.assigntoRoletitle = "Submit to Attorney";
                this.assigntoroletxt = "Attorney";
                this.chooseassigntorole = "Choose Attorney";
                this.rolesubmitaction = "ASSIGN_ATTORNEY";
            }
            if (roleId == 8) {
                this.assigntoRoletitle = "Submit to Offshore Manager";
                this.assigntoroletxt = "Manager";
                this.chooseassigntorole = "Choose Offshore Manager";
                this.rolesubmitaction = "ASSIGN_OFFSHORE_MANAGER";
            }
            if (this.selectedroleslist) this.selectedroleslist = [];
            if (this.assigntoroleModel) this.assigntoroleModel = [];
            if (this.assignedrolecomments != "") this.assignedrolecomments = "";
            this.$store.dispatch("getusersByrole", roleId).then((response) => {
                this.selectedroleslist = response.list;
            });
        },
        submitFilingFees() {
            this.$validator.validateAll("filingFeesform").then((result) => {
                if (result) {
                    var totala = 0;
                    this.filingFeeData.forEach((i) => {
                        totala = totala + i.amount;
                    });
                    
                    var postdata = {
                        companyName: this.petition.petitionerDetails.name,
                        beneficiaryName: this.petition.beneficiaryDetails.name,
                        beneficiaryCustomId: this.petition.beneficiaryDetails.customId,
                        petitionType: this.petition.typeDetails.name,
                        companyId: this.petition.petitionerDetails._id,
                        petitionId: this.petition._id,
                        feeDetails: this.filingFeeData,
                        amount: totala,
                        today: moment().format("YYYY-MM-DD"),
                        customer: {
                            Id: this.petition.companyDetails.qbCustomerId,
                            displayName: this.petition.companyDetails.name,
                            email: this.petition.companyDetails.authorizedSignatory.email,
                        },
                        invoiceTerms: {
                            days: 30,
                        },
                    };
                    if (this.petition.invoiceId != null) {
                        postdata.invoiceId = this.petition.invoiceId;
                        postdata.statusId = 2;
                        postdata.statusName = "Sent";
                        this.$store
                            .dispatch("updateFilingFees", postdata)
                            .then((response) => {
                                this.$emit("updatepetition");

                                this.showMessages(response.message);
                                this.filingFeesPopup = false;
                            });
                    } else {

                        this.$store
                            .dispatch("submitFilingFees", postdata)
                            .then((response) => {
                                this.$emit("updatepetition");
                                this.showMessages(response.message);
                                this.filingFeesPopup = false;
                            });

                    }

                }
            });
        },
        submitpetitionrequest() {
            var postdata = {
                petitionId: this.petition._id,
                comments: this.requestsignformcomments,
            };

            this.$store.dispatch("requestforsign", postdata).then((response) => {
                this.$emit("updatepetition");
                this.showMessages(response.message);
                this.requestsignPopup = false;
            });
        },
        addfilingfee: function () {
            this.filingFeeData.push({
                amount: null,
                description: "",
            });
        },
        removefilingfee: function (index) {
            Vue.delete(this.filingFeeData, index);
        },
        submitassignrole() {
            this.$validator.validateAll("assignroleform").then((result) => {
                if (result) {
                    var postdata = {
                        petitionId: this.petition._id,
                        userId: this.assigntoroleModel._id,
                        userName: this.assigntoroleModel.name,
                        roleId: this.assignedRoleId,
                        typeName: this.petition.typeDetails.name,
                        subTypeName: this.petition.subTypeDetails.name,
                        comment: this.assignedrolecomments,
                        action: this.rolesubmitaction,
                        submitted: true,
                    };

                    this.$store.dispatch("gcpassigntoarole", postdata).then((response) => {
                        this.$emit("updatepetition");
                        this.showMessages(response.message);
                        this.assigntoRolePopup = false;
                    });
                }
            });
        },
        change_superwiser() {
            if (this.currentRole == 5) {
                this.SubmitParalegal = true;
                this.is_change_superwiser = true;
            }
        },
        change_paralegal() {
            if (this.currentRole == 5 || this.currentRole == 3) {
                this.replaceParalegaltitle = "Replace Paralegal";
                this.replaceParalegal = true;
                this.approveParalegalform = false;
                this.is_change_paralegal = true;
            }

            //alert("change_paralegal");
        },

        replaceparalegal() {
            this.replaceParalegaltitle = "Replace Paralegal";
            this.replaceParalegal = true;
            this.approveParalegalform = false;
            this.is_change_paralegal = false;
            this.pactiontype = "ASSIGN_PARALEGAL";
        },
        approveparalegal() {
            this.replaceParalegaltitle = "Approve Paralegal";
            this.replaceParalegal = true;
            this.approveParalegalform = true;
            this.pactiontype = "APPROVE_PARALEGAL";
        },
        submitapproveparalegal() {
            this.$validator.validateAll("approveparalegalfoform").then((result) => {
                if (result) {
                    var paralegalid = this.petition.paralegalDetails._id;
                    var userName = this.petition.paralegalDetails.name;
                    if (
                        this.paralegalModel != null &&
                        this.approveParalegalform == false
                    ) {
                        paralegalid = this.paralegalModel._id;
                        userName = this.paralegalModel.name;
                    }
                    var postdata = {
                        petitionId: this.petition._id,
                        userId: this.petition.paralegalDetails._id,
                        userName: this.petition.paralegalDetails.name,
                        roleId: 4,
                        typeName: this.petition.typeDetails.name,
                        subTypeName: this.petition.subTypeDetails.name,
                        comment: this.supervisorcomments,
                        action: this.pactiontype,
                        submitted: true,
                    };

                    if (this.is_change_paralegal) {
                        //alert("ACTION");
                        
                        postdata["userId"] = this.paralegalModel._id;
                        postdata["userName"] = this.paralegalModel.name;
                        postdata["typeName"] = this.paralegalModel.roleDetails[0]["name"];
                        postdata["action"] = "REPLACE_PARALEGAL";
                        postdata["lastUserName"] = this.petition.paralegalDetails.name;
                        //return false;
                    }
                    //petition/assign-a-role

                    this.$store.dispatch("assigntoarole", postdata).then((response) => {
                        this.$emit("updatepetition");
                        this.showMessages(response.message);
                        this.replaceParalegal = false;
                    });
                }
            });
        },
        assignparalegalform() {
            this.$validator.validateAll("paralegalfoform").then((result) => {
                if (result) {
                    // this.showMessages(JSON.stringify(this.petition.typeDetails));
                    
                    var postdata = {
                        petitionId: this.petition._id,
                        userId: this.paralegalModel._id,
                        userName: this.paralegalModel.name,
                        roleId: 4,
                        //    typeName: this.petition.typeDetails.name,
                        //  subTypeName: this.petition.subTypeDetails.name,
                        comment: this.supervisorcomments,
                        action: "ASSIGN_PARALEGAL",
                    };

                    // alert(JSON.stringify(postdata));

                    this.$store.dispatch("gcpassigntoarole", postdata).then((response) => {
                        this.$emit("updatepetition");
                        this.showMessages(response.message);
                        this.AssignParalegal = false;
                    });
                }
            });
        },
        checker(value) {
            this.documentlockformcomments = "";

            this.lockDocumentsPopup = true;
            this.lockDocumentsPopupTitle = "Lock Application Editing";
            if (!value) this.lockDocumentsPopupTitle = "Unlock Application Editing";
            this.documentsUpload = value;
        },
        submitdocumentslock() {
            this.$validator.validateAll("documentlockform").then((result) => {
                if (result) {
                    var postdata = {
                        petitionId: this.petition._id,
                        today: moment().format("YYYY-MM-DD"),
                        comment: this.documentlockformcomments,
                        action: this.documentsUpload ?
                            "DISABLE_EDIT_OPTION" :
                            "ENABLE_EDIT_OPTION",
                    };

                    this.$store
                        .dispatch("managegcediting", postdata)
                        .then((response) => {
                            this.showMessages(response.message);
                            this.lockDocumentsPopup = false;
                            this.documentlockformcomments = "";
                            this.petition.documentsUploadEnabled = this.documentsUpload;
                            this.$emit("updatepetition");
                        });
                }
            });
        },

        assignsupervisorform() {
            this.$validator.validateAll("supervisorform").then((result) => {
                if (result) {
                    var postdata = {
                        petitionId: this.petition._id,
                        userId: this.supervisorMode._id,
                        userName: this.supervisorMode.name,
                        roleId: 3,
                        typeName: this.petition.typeDetails.name,
                        subTypeName: this.petition.subTypeDetails.name,
                        comment: this.paralegalcomments,
                        action: "ASSIGN_SUPERVISOR",
                        submitted: true,
                    };

                    this.$store.dispatch("assigntoarole", postdata).then((response) => {
                        this.$emit("updatepetition");
                        this.showMessages(response.message);
                        this.SubmitParalegal = false;
                    });
                }
            });
        },
        approveOrreject(action_type = 1) {
            this.approveRejectTitle = "Approve Questionnaire";
            this.actionType = "approved";
            this.approveRejecInstructions = "";

            this.actionType = 1;
            if (action_type == "approved") {
                this.actionType = "approved";
                this.approveRejectTitle = "Approve Questionnaire";
                this.approveaction = true;
                this.$emit("passparent", 3);
            }
            if (action_type == "rejected") {
                this.actionType = "rejected";
                this.approveRejectTitle = "Reject Questionnaire";
                this.approveaction = false;
                this.approveRejectPop = true;
            }
        },
        saveApproveOrreject() {
            //alert(this.approveRejecInstructions);

            this.$validator.validateAll("approverejectquestion").then((result) => {
                if (result) {
                    // this.approveRejec_Instructions="* Instructions is required"

                    let payload_data = {
                        petitionId: this.petition._id,
                        comment: this.approveRejecInstructions,
                    };
                    // "action": "QUESTIONNIRE_APPROVED" // "QUESTIONNIRE_REJECTED" / "CASE_APPROVED" / "LCA_CERTIFIED_FOR_PETITION" / "READY_FOR_FILING" / "USCIS_APPROVED" / "USCIS_RECEIVED_RFE" / "USCIS_DENIED"

                    if (this.actionType == "approved") {
                        payload_data["action"] = "QUESTIONNIRE_APPROVED";
                    } else {
                        payload_data["action"] = "QUESTIONNIRE_REJECTED";
                    }
                    this.$store
                        .dispatch("manageApproval_process", payload_data)
                        .then((response) => {
                            this.$emit("updatepetition");
                            this.showMessages(response.message);
                            this.approveRejectPop = false;
                        });
                }
            });
        },
        petitionApproval() {
            //alert(this.approveRejecInstructions);

            this.$validator.validateAll("uscisstatus").then((result) => {
                if (result) {
                    // this.approveRejec_Instructions="* Instructions is required"

                    let payload_data = {
                        petitionId: this.petition._id,
                        comment: this.usciscomments,
                        action: this.casestatus.value,
                    };

                    let rfepayload = {
                        petitionId: this.petition._id,
                        comment: this.usciscomments,
                        description: this.usciscomments,
                        action: this.casestatus.value,
                    };
                    // "action": "QUESTIONNIRE_APPROVED" // "QUESTIONNIRE_REJECTED" / "CASE_APPROVED" / "LCA_CERTIFIED_FOR_PETITION" / "READY_FOR_FILING" / "USCIS_APPROVED" / "USCIS_RECEIVED_RFE" / "USCIS_DENIED"

                    if (this.casestatus.value == "USCIS_RECEIVED_RFE") {
                        payload_data["today"] = moment().format("YYYY-MM-DD");
                        payload_data["typeName"] = this.petition.typeDetails.name;
                        payload_data["subTypeName"] = this.petition.subTypeDetails.name;

                        rfepayload["today"] = moment().format("YYYY-MM-DD");
                        rfepayload["typeName"] = this.petition.typeDetails.name;
                        rfepayload["subTypeName"] = this.petition.subTypeDetails.name;

                        rfepayload["issuedDate"] = moment(this.issuedDate).format(
                            "YYYY-MM-DD"
                        );
                        rfepayload["receivedDate"] = moment(this.receivedDate).format(
                            "YYYY-MM-DD"
                        );
                        rfepayload["dueDate"] = moment(this.dueDate).format("YYYY-MM-DD");
                        rfepayload["documents"] = this.uscisdocument;
                    }
                    this.$store
                        .dispatch("manageApproval_process", rfepayload)
                        .then((response) => {
                            if (this.casestatus.value == "USCIS_RECEIVED_RFE") {
                                this.$store.dispatch("fileRFE", rfepayload).then((response) => {
                                    this.$emit("updatepetition");
                                    this.showMessages(response.message);
                                    this.updateUSCISstatusPopup = false;
                                });
                            } else {
                                this.$emit("updatepetition");
                                this.showMessages(response.message);
                                this.updateUSCISstatusPopup = false;
                            }
                        });
                }
            });
        },
        gethistory() {
            this.$store
                .dispatch("petitionhistory", this.petition._id)
                .then((response) => {
                    this.petitionhistory = response.result.list;
                });
        },
        reloadPetition() {
            this.$store
                .dispatch("getpetition", this.petition._id)
                .then((response) => {
                    this.petition = response.data.result;
                    if (this.petition.lcaId != null) {
                        this.$store
                            .dispatch("fetchLcaDetails", this.petition.lcaId)
                            .then((response) => {
                                this.lcaDetails = response.data.result;
                            });
                    }

                    let postDt = {userId:'' ,isRfeCase:false}
                    if(_.has(this.petition ,"rfeCase" )){
                    postDt['isRfeCase'] = this.petition['rfeCase']
                    }
                    postDt['userId'] = this.petition['userId'];
                    this.$store
                        .dispatch("getpetitionsdropdown", postDt)
                        .then((response) => {
                            this.petitions = response;
                        });
                });
            this.$store.dispatch("petitionhistory", petitionId).then((response) => {
                this.petitionhistory = response.result.list;
            });
        },
        showMessages(message) {
            this.$vs.notify({
                title: "Success",
                position: "top-right",
                color: "success",
                iconPack: "feather",
                icon: "icon-check",
                text: message,
            });
        },
        selectedDocuments(index, docs) {
            let formData = new FormData();
            docs = docs.map(
                (item) =>
                (item = {
                    name: item.name,
                    file: item.file,
                    url: "",
                    mimetype: item.type,
                })
            );

            if (docs.length > 0) {
                var self = this;
                docs.forEach(function (doc) {
                    formData.append("files", doc.file);
                    formData.append("secureType", "private");
                    self.$store.dispatch("uploadS3File", formData).then((response) => {
                        if (response.data && response.data.result) {
                            response.data.result.forEach((urlGenerated) => {
                                doc.url = urlGenerated;
                                delete doc.file;
                                self.tracking.documents = docs;
                                self.uscisdocument = docs;
                                self.trackingdoc = docs;
                                self.documentData.documentUploaded = docs;
                                
                            });
                        }
                    });
                });
            }
        },
    },
    mounted() {
        this.getCourierList();
        
        this.$store.dispatch("getusersByrole", 4).then((response) => {
            this.paralegallist = response.list;

        });
        this.$store.dispatch("getusersByrole", 3).then((response) => {
            this.supervisorlist = response.list;
        });

        //this.gethistory();
        setTimeout(function () {
            if (JQuery(".petition-action-content").find("li").length > 0) {
                // JQuery('.flowdropdown').show();
            } else {
                // JQuery('.flowdropdown').hide();
            }
        }, 2500);
    },
};
</script>
